import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useSearchMixDetailsContext } from "../../context/SearchMixDetailsContext";
import { useMassFormatter } from "hooks/useMassFormatter";
import { useHoveredMaterialContext } from "contexts/HoveredMaterialContext";

export const BasketsTabTotalsTable = () => {
  const { t } = useTenantTranslation();
  const { sortedMaterials } = useSearchMixDetailsContext();
  const { hoveredMaterial, setHoveredMaterial } = useHoveredMaterialContext();
  const { formatMass } = useMassFormatter();

  return (
    <div>
      <Typography variant="h6" sx={{ mb: 1, fontWeight: "fontWeightBold" }}>
        {t("materialTotals")}
      </Typography>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          maxWidth: 300,
          overflow: "hidden",
          border: 1,
          borderColor: "grey.300",
        }}
      >
        <Table size="small" sx={{ "& .MuiTableCell-root": { py: 0.5 } }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ fontWeight: "fontWeightBold", fontSize: "0.8rem" }}
              >
                {t("material")}
              </TableCell>
              <TableCell
                align="right"
                sx={{ fontWeight: "fontWeightBold", fontSize: "0.8rem" }}
              >
                {t("totalMass")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedMaterials.map((material) => {
              const isHovered = hoveredMaterial === material.name;

              return (
                <TableRow
                  key={material.name}
                  onMouseEnter={() => {
                    setHoveredMaterial(material.name);
                  }}
                  onMouseLeave={() => {
                    setHoveredMaterial(null);
                  }}
                  sx={{
                    cursor: "pointer",
                    backgroundColor: isHovered ? "action.hover" : "transparent",
                  }}
                >
                  <TableCell sx={{ fontSize: "0.8rem" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <span>{material.name}</span>
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          backgroundColor: material.color,
                          border: "1px solid rgba(0,0,0,0.2)",
                          flexShrink: 0,
                        }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ fontWeight: "fontWeightBold", fontSize: "0.8rem" }}
                  >
                    {formatMass(material.totalMass)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
